module.exports = __webpack_public_path__ + "img/chest5.37fdf874.png";